import React from 'react';
import PropTypes from 'prop-types';
import { Spinner, SpinnerSize } from '@bingads-webui-react/fabric-control';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getSpinnerStyles } from '../../styles/shared-components/spinner-styles';

const SpinnerImpl = ({ message, classes }) => (
  <div className={classes.spinnerContainer}>
    <Spinner className="spinner" size={SpinnerSize.medium} />
    <span className="message">{message}</span>
  </div>
);

SpinnerImpl.propTypes = {
  message: PropTypes.string,
  classes: PropTypes.shape({}).isRequired,
};

SpinnerImpl.defaultProps = {
  message: '',
};

export const SpinnerWithMessage = withDefaultStyles(SpinnerImpl, getSpinnerStyles);
